











import MapComp from "../components/Map.vue";
import PositionError from "../components/PositionError.vue";
import { MapState } from "../vuex/store";
import Vue from "vue"
import About from "@/components/About.vue";

export default Vue.extend({

	metaInfo():any {

		const id = this.$store.state.map ? this.$store.state.map.id : "";
		const title = `Digitala Midnattsloppet - ${this.name}`;
		const desc = "Här är mitt eget Digitala Midnattslopp!";

		return {
			title: title,
			meta: [
				{
					vmid: "description",
					name: "description",
					content: desc,
				},
				{
					vmid: "og:title",
					property: "og:title",
					content: title,
				},
				{
					vmid: "og:description",
					property: "og:description",
					content: desc,
				},
				{
					vmid: "og:image",
					property: "og:image",
					content: `${this.base}/.netlify/functions/getStaticImage?id=${id}&r=${Math.random()}`,
				},
				{
					vmid: "og:image:height",
					property: "og:image:height",
					content: "314",
				},
				{
					vmid: "og:image:width",
					property: "og:image:width",
					content: "600",
				},
				{
					vmid: "og:image:type",
					property: "og:image:type",
					content: "image/png",
				},
			]
		}
	},
	
	components: {
		MapComp,
		PositionError,
		About
	},

	data() {
		return {
			// MapState,
			showPositionError: false,
		}
	},

	mounted() {
		//@ts-ignore
		window.prerenderReady = true;
	},

	computed: {
		MapState: () => MapState,

		name() : string {
			return this.$store.state.map ? this.$store.state.map.name : "";
		},

		showAbout() : boolean {
			return this.$route.name == "about";
		},

		base() {
			return window.location.origin;
		},
	},

	methods: {
		// prevent zooming with wheel since ctrl-scroll zooms the map,
		// and it's annoying to zoom when you accidenatly hover another element
		wheelHandler(evt) {
			if(evt.ctrlKey) {
				evt.preventDefault();
			}
		},

		onPositionError() {
			this.showPositionError = true;
		}
	},

	watch: {
		$route:{
			handler: function(to, from) {
				if(from && to && from.params.id == to.params.id && !from.path.includes("editor"))
					return;
				this.$store.dispatch("loadMap", to.params.id);
			},
			immediate: true,
		}
	}
})
